<div *ngIf="answer" style="display: flex; flex-direction: column; flex: 1">
  <div style="display: flex; flex-direction: column; padding: 0 20px 10px 20px">
    <div style="flex: 1">
      <div *ngIf="question.type == 'pick-list'">
        <h5 style="margin: 0 20px 10px 20px">Options</h5>
        <ul style="font-size: 12px">
          <li *ngFor="let o of question?.options">{{ o?.text }}</li>
        </ul>
      </div>

      <div class="answer-wrapper" [ngClass]="{ active: editing }" *ngIf="!isPictureOrLocationOnly(question)">
        <h5>{{ question?.inspectorVisibility === 'never' ? 'Admin' : 'Inspector' }}'s answer</h5>

        <form [formGroup]="form" (submit)="submit()" style="text-align: right">
          <div class="form-group">
            <textarea
              *ngIf="question?.type !== 'pick-list'"
              class="form-control"
              formControlName="answer"
              [ngClass]="getValidationClass('answer')"></textarea>
            <select
              *ngIf="question?.type === 'pick-list'"
              class="form-control"
              formControlName="answer"
              (change)="changeAnswer()">
              <option *ngIf="question?.inspectorVisibility === 'never'" [ngValue]="''" selected></option>
              <option *ngFor="let a of question?.options" [ngValue]="a?.text">{{ a?.text }}</option>
            </select>
          </div>
          <div style="height: 28px">
            <button
              [disabled]="!form.valid"
              type="button"
              class="btn btn-sm btn-link"
              *ngIf="editing"
              (click)="changeAnswer()">
              Save
            </button>

            <button *ngIf="!editing" type="button" class="btn btn-sm btn-link hover-button" (click)="editing = true">
              Edit
            </button>
          </div>
        </form>
      </div>

      <div *ngIf="showMap" style="height: 300px">
        <app-mapbox (load)="setMap($event)" (styleLoaded)="styleLoaded()" [minZoom]="17"></app-mapbox>
      </div>

      <a
        style="font-size: 17px; padding: 10px 5px; display: inline-block"
        href="javascript:void(0)"
        *ngIf="ownPictures?.length || relatedPictures?.length"
        (click)="showPictures()">
        <i class="fa fa-camera"></i
        ><span *ngIf="ownPictures?.length">
          {{ ownPictures?.length }} image{{ ownPictures?.length > 1 ? 's' : '' }}</span
        >
        <span *ngIf="ownPictures?.length && relatedPictures?.length">+</span>
        <span *ngIf="relatedPictures?.length">
          {{ relatedPictures?.length }} related image{{ relatedPictures?.length > 1 ? 's' : '' }}</span
        >
      </a>

      <a class="add-image" (click)="addImage()" href="javascript:void(0)"><i class="fa fa-plus"></i> Add image</a>

      <a
        style="font-size: 17px; padding: 10px 5px; display: block"
        href="javascript:void(0)"
        *ngIf="answer?.flags?.length"
        (click)="showPictures()">
        <i class="fa fa-flag"></i
        ><span> {{ answer?.flags?.length }} flag{{ answer?.flags?.length > 1 ? 's' : '' }}</span>
      </a>
    </div>
    <div style="padding: 25px 0 0 25px; text-align: left; color: #555">
      <div style="display: inline-block; font-size: 14px">
        <i class="fa fa-user-circle"></i> {{ inspection?.inspector?.name }} ({{ dateTimeAsString(answer.createdAt) }})
      </div>
    </div>
  </div>

  <div style="text-align: center; display: flex; flex-direction: column; flex: 1">
    <div [ngStyle]="{ flex: !accordion.active ? 1 : '' }"></div>

    <div
      class="accordion-button"
      [ngClass]="{ active: accordion.active == 'comments' }"
      (click)="accordion.toggle('comments')">
      <div style="flex: 1">
        Notes & comments <span style="color: #2763cd">({{ answer?.comments?.length }})</span>
      </div>
      <i
        class="fa"
        [ngClass]="{
          'fa-chevron-down': accordion.active !== 'comments',
          'fa-chevron-up': accordion.active == 'comments'
        }"></i>
    </div>
    <div
      *ngIf="accordion.active == 'comments'"
      style="position: relative; flex: 1; border-bottom: 1px solid #dce6f5; min-height: 200px">
      <div class="accordion" forScroll>
        <form (submit)="addComment(newComment.value); newComment.value = ''">
          <div class="form-group" style="position: relative">
            <input
              type="text"
              class="form-control"
              style="padding: 10px 30px 10px 10px"
              placeholder="Add new Comment"
              #newComment />
            <button type="submit" class="btn" style="position: absolute; top: 0; right: 0px; color: #2763cd">
              <i class="fa fa-arrow-right"></i>
            </button>
          </div>
        </form>

        <div
          style="
            background-color: #dee7f5;
            border-radius: 4px;
            color: #3465c4;
            padding: 15px;
            margin-bottom: 15px;
            display: flex;
            text-align: left;
          "
          *ngFor="let comment of answer.comments; index as i">
          <div>
            <i class="fa fa-comment"></i>
          </div>
          <div style="flex: 1; padding: 0 20px">
            <p style="font-weight: bold; margin: 0 0 10px">{{ comment.text }}</p>
            <p style="color: #444; margin: 0; font-size: 13px">
              {{ dateAsString(comment.date) }} / {{ comment.username }}
            </p>
          </div>
          <div>
            <i style="cursor: pointer" class="fa fa-trash" (click)="removeComment(i)"></i>
          </div>
        </div>
      </div>
    </div>

    <div
      class="accordion-button"
      [ngClass]="{ active: accordion.active == 'changes' }"
      style="border-top: 0"
      (click)="accordion.toggle('changes')">
      <div style="flex: 1">
        Changelog <span style="color: #2763cd">({{ answer?.changes?.length }})</span>
      </div>
      <i
        class="fa"
        [ngClass]="{
          'fa-chevron-down': accordion.active !== 'changes',
          'fa-chevron-up': accordion.active == 'changes'
        }"></i>
    </div>
    <div
      *ngIf="accordion.active == 'changes'"
      style="position: relative; flex: 1; border-bottom: 1px solid #dce6f5; min-height: 200px">
      <div class="accordion" forScroll>
        <div
          style="
            margin-left: 15px;
            color: #3465c4;
            padding: 0 0 20px 0;
            display: flex;
            text-align: left;
            border-left: 3px solid #dae5f9;
            position: relative;
          "
          *ngFor="let c of answer.changes; index as i">
          <i
            style="
              position: absolute;
              top: 0;
              left: -13px;
              padding: 5px;
              border-radius: 50%;
              background-color: #dae5f9;
              color: #93baff;
            "
            class="fa"
            [ngClass]="getChangeIcon(c)"></i>

          <div>
            <i
              class="fa"
              [ngClass]="{
                'fa-comment': c?.changelogs?.type === 'CommentChange',
                'fa-close': c?.changelogs?.type === 'RejectChange',
                'fa-flag': c?.changelogs?.type === 'FlagChange',
                'fa-trash': c?.changelogs?.type === 'DeleteChange',
                'fa-pencil': c?.changelogs?.type === 'EditChange',
                'fa-refresh': c?.changelogs?.type === 'unreviewed',
                'fa-check-circle': c?.changelogs?.type === 'AcceptChange'
              }"></i>
          </div>
          <div style="flex: 1; padding: 0 20px">
            <p style="font-weight: bold; margin: 0 0 4px">
              {{ c.username }}
              <span
                *ngIf="c.user"
                style="
                  background-color: #fff;
                  height: 30px;
                  border-radius: 15px;
                  padding: 3px 8px;
                  font-weight: bold;
                  font-weight: 10px;
                ">
                {{ c.user.type === 'AdminUser' ? 'Admin' : c.user?.type }}
              </span>
              <span style="color: #2763cd; margin: 0; font-size: 11px; float: right; line-height: 21px">
                {{ dateTimeAsString(c.date) }}
              </span>
            </p>

            <p
              style="color: #444; margin: 0; font-size: 13px; cursor: pointer"
              (click)="openChangeAccordion(c?.log?.type)">
              <span>{{ buildSentence(c) }}</span>
              <span *ngIf="isBulkChange(c)" class="changelog-bulk">Bulk</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div style="padding: 15px 0">
      <button
        type="button"
        class="btn aru"
        *ngIf="showNavigation"
        style="width: 46px; padding: 12px; height: 46px; color: #2763cd; margin: 5px 5px 0 20px; float: left"
        (click)="previousQuestion.emit()">
        <i class="fa fa-arrow-left"></i>
      </button>

      <button
        type="button"
        class="btn aru"
        [disabled]="shouldDisableButton()"
        *ngIf="question?.inspectorVisibility !== 'never'"
        style="margin: 5px"
        [ngClass]="{
          'btn-outline-danger': answer.status !== AnswerStatus.REJECTED,
          'btn-danger': answer.status === AnswerStatus.REJECTED
        }"
        (click)="reject()">
        {{ answer.status === AnswerStatus.REJECTED ? 'Rejected' : 'Reject' }}
      </button>

      <button
        type="button"
        class="btn aru btn-ghost-danger"
        *ngIf="question?.inspectorVisibility !== 'never'"
        style="margin: 5px"
        (click)="addFlag()">
        Flag
      </button>

      <button
        type="button"
        class="btn aru"
        [disabled]="shouldDisableButton()"
        style="margin: 5px"
        [ngClass]="{
          'btn-outline-success': answer.status !== AnswerStatus.ACCEPTED,
          'btn-success': answer.status === AnswerStatus.ACCEPTED
        }"
        (click)="accept()">
        {{ answer.status === AnswerStatus.ACCEPTED ? 'Accepted' : 'Accept & next' }}
      </button>

      <button
        type="button"
        class="btn aru"
        *ngIf="showNavigation"
        style="width: 46px; padding: 12px; height: 46px; color: #2763cd; margin: 5px 20px 0 5px; float: right"
        (click)="nextQuestion.emit()">
        <i class="fa fa-arrow-right"></i>
      </button>
    </div>
  </div>

  <app-add-flag #addFlagModal></app-add-flag>
  <app-edit-flag #editFlagModal></app-edit-flag>
  <app-upload-image #uploadImageModal [inspectionId]="inspection.id"></app-upload-image>
</div>
